'use strict';

var React = require('react'),
    IconMixin = require('../../mixins/IconMixin');

var ClockIcon = React.createClass({
  mixins: [IconMixin],

  renderSVG: function (size) {
    switch (size) {
    case 'small':
      return '<line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="9" y1="4" x2="9" y2="9"/><line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="11.83" y1="11.83" x2="9" y2="9"/><circle stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" cx="9" cy="9" r="8"/>';
    case 'medium':
      return '<line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="16" y1="6.63" x2="16" y2="16"/><line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="21.3" y1="21.3" x2="16" y2="16"/><circle stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" cx="16" cy="16" r="15"/>';
    case 'large':
      return '<line stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="24" y1="10.25" x2="24" y2="24"/><line stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="31.756" y1="31.756" x2="24.244" y2="24.244"/><circle stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" cx="24" cy="24" r="22.5"/>';
    }
  }
});

module.exports = ClockIcon;



/** WEBPACK FOOTER **
 ** ./atoms/icons/Clock.jsx
 **/